import { Injectable, inject } from '@angular/core';
import { type Observable } from 'rxjs';
import { AppSettings } from '@pecan/config';
import { HttpClient } from '@angular/common/http';
import { type ICountriesDto } from '@pecan/api';

@Injectable({
    providedIn: 'root',
})
export class CountryHttpService {
    private _http: HttpClient = inject(HttpClient);

    public getCountries(): Observable<ICountriesDto> {
        return this._http.get<ICountriesDto>(`${AppSettings.apiHost}/serialnumber/v2/info/countries`);
    }
}
